/**
 * Оновити ВСІ списки довідника після створення чи зміни запису (ч.1267).
 *
 * Сторінки тримають списки одного довідника під різними ключами кешу: випадаючі списки
 * документів беруть контрагентів з `contractors-all`, картки — з `contractors`, розпізнавання
 * — з `contractors-full`. Кожна сторінка після швидкого створення оновлювала «свій» ключ, і
 * часто не той, з якого читає її ж випадаючий список: створений контрагент, договір чи
 * номенклатура не зʼявлявся у списку, доки не оновиш сторінку (скарга бухгалтерів).
 * Тому оновлюємо за РОДИНОЮ ключів, а не за одним ключем.
 */
import type { QueryClient } from '@tanstack/react-query';

export type RefFamily = 'contractors' | 'contracts' | 'nomenclature';

const FAMILY: Record<RefFamily, (key: string) => boolean> = {
  // contractors, contractors-all, contractors-full, contractors-for-select, contractor-…
  contractors: (k) => /^contractors?(-|$)/.test(k),
  // contracts, contracts-org, contract-detail, … і договори в картці контрагента
  contracts: (k) => /^contracts?(-|$)/.test(k) || k === 'contractor-contracts',
  // nomenclature, nomenclature-full, nomenclature-all, nomenclature-for-picker, …
  nomenclature: (k) => /^nomenclature(-|$)/.test(k),
};

/** Чи належить ключ кешу до родини довідника (для тестів і сторожа). */
export function isRefListKey(family: RefFamily, queryKey: readonly unknown[]): boolean {
  const head = queryKey[0];
  return typeof head === 'string' && FAMILY[family](head);
}

export function invalidateRefLists(qc: QueryClient, ...families: RefFamily[]): void {
  for (const family of families) {
    void qc.invalidateQueries({ predicate: (q) => isRefListKey(family, q.queryKey) });
  }
}
